import {getApiRequestBuilder, postApiRequestBuilder} from "@utils/RequestBuilder";


export function getOperatorCounter() {
	return getApiRequestBuilder('operator/counter').send();
}

export function applyOperatorProjectVideoLinks(projectId, originalLinkVideo, linkVideo) {
	return postApiRequestBuilder(`/operator/project/${projectId}/video-links`).send({originalLinkVideo, linkVideo});
}

export function getOperatorProjectVideoLinks(projectId) {
	return getApiRequestBuilder(`/operator/project/${projectId}/video-links`).send();
}